import React, { useState, useEffect } from 'react';
import { Select } from 'tea-component';

interface TimeSelectComponentProps {
    value: any;
    record: any;
    editData?: any[];
    disabled?: boolean;
    stableUpdater?: (value: any) => void;
    hasError?: boolean;
}

const TimeSelectComponent: React.FC<TimeSelectComponentProps> = ({
    value,
    record,
    editData,
    disabled,
    stableUpdater,
    hasError = false
}) => {
    const getCurrentValue = () => {
        if (editData && record?.id) {
            const editRecord = editData.find((item: any) => item.id === record.id);
            if (editRecord && editRecord.expected_time !== undefined) {
                return editRecord.expected_time;
            }
        }
        return value || '';
    };

    const [selectedValue, setSelectedValue] = useState(getCurrentValue());

    // Sync with editData changes (for auto-save restore) and record.id changes
    useEffect(() => {
        setSelectedValue(getCurrentValue());
    }, [record?.id, editData]);

    const handleChange = (newValue: any) => {
        setSelectedValue(newValue);
        if (stableUpdater) {
            stableUpdater(newValue);
        }
    };

    // 生成所有选项：月份 + 周
    const generateTimeOptions = () => {
        const options: { value: string; text: string }[] = [];
        const months = [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
        ];

        months.forEach(month => {
            // 添加月份选项
            options.push({
                value: month,
                text: month
            });

            // 添加该月的周选项
            for (let week = 1; week <= 5; week++) {
                options.push({
                    value: `${month}, Week ${week}`,
                    text: `${month}, Week ${week}`
                });
            }
        });

        return options;
    };

    const timeOptions = generateTimeOptions();

    return (
        <Select
            style={{
                width: '100%',
            }}
            overlayClassName="dbs-time-select-overlay"
            searchable
            listWidth={200}
            listHeight={300}
            appearance="button"
            value={selectedValue}
            onChange={handleChange}
            options={timeOptions}
            placeholder="Select time"
            disabled={disabled}
        />
    );
};

export default TimeSelectComponent;
